<!--
 * @Author: your name
 * @Date: 2020-02-18 17:12:41
 * @LastEditTime: 2020-03-02 13:36:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/ListShow.vue
 -->
<template>

  <div class="listShow2">
  </div>
</template>

<script>
//import Cookies from 'js-cookie'

export default {
  name: 'Middle',
  data() {
    return {
        
    }   
  },

  methods: {
    
  },
  mounted: function () {
    //   Cookies.remove('openid')
    //   Cookies.remove('uid')
    this.$router.go(-1)
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/Middle.vue